import { useRef, useEffect } from 'react';
export default function useDefer(func, timeout) {
  const timerId = useRef();
  const defer = (...args) => {
    timerId.current = window.setTimeout(func, timeout, ...args);
  };
  const cancel = () => {
    if (timerId.current) {
      window.clearTimeout(timerId.current);
    }
  };
  // Cancel now, just in case, but also on unmount:
  useEffect(() => cancel);
  return [defer, cancel];
}